import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from './store';

interface Asset {
  id: number;
  chainId: number;
  currency: string;
  chainType: number;
  chainCode: string;
  tokenName: string;
  assetName: string;
  decimals: number;
  displayName: string;
  networkDisplayName: string;
  createdDate: Date;
  lastModifiedDate: Date;
  displayDecimals: number;
  enabled: boolean;
  abccAssetName: string;
  mappedDisplayName: string;
  mappedNetworkDisplayName: string;
  mappedTokenName: string;
  displaySequence: number;
}

interface InitState {
  list: Asset[];
}

const initialState: InitState = { list: [] };

export const assetsListSlice = createSlice({
  name: 'assetsSlice',
  initialState,
  reducers: {
    setAssetsList: (state, action: PayloadAction<Asset[]>) => {
      state.list = action.payload;
    },
  },
});

export const { setAssetsList } = assetsListSlice.actions;

export const selectAssetsList = (state: RootState) => state.assets;
export default assetsListSlice.reducer;
